import { makeStylesV5 } from '../../index';
export default makeStylesV5()(() => ({
    fileListWrapper: {
        marginTop: '4px',
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 8px',
        justifyContent: 'center',
        alignItems: 'flex-start',
        '&:hover.valid': {
            background: 'rgba(0, 92, 102, 0.04)',
            '& .fileInfo': {
                '& .fileNameWrapper': {
                    '&.valid': {
                        color: '#00636E',
                    },
                    '& .fileIconWrapper.valid': {
                        color: '#007A87',
                    },
                }
            },
        },
        '&.valid': {
            background: '#FAFAFA',
        },
        '&.inValid': {
            background: '#FDEDED',
        },
        '& .fileInfo': {
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'stretch',
            gap: '8px',
            '& .fileNameWrapper': {
                flex: '1 0 0',
                WebkitBoxOrient: 'vertical',
                textWrap: 'wrap',
                textOverflow: 'ellipsis',
                overflowX: 'hidden',
                whiteSpace: 'break-spaces',
                color: '#5F2120',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '150%',
                letterSpacing: '0.15px',
                '&.valid': {
                    color: 'rgba(0, 0, 0, 0.87)',
                },
                '&.noFileInfo': {
                    color: 'rgba(0, 0, 0, 0.38)',
                },
                '&.inValid': {
                    color: '#5F2120',
                },
                '& .fileIconWrapper': {
                    '&.valid': {
                        color: '#9E9E9E',
                    },
                    '&.inValid': {
                        color: '#D91C03',
                    },
                    width: '20px',
                    marginRight: '4px',
                },
            },
            '& .fileSizeWrapper': {
                textAlign: 'right',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '150%',
                letterSpacing: '0.15px',
                '&.valid': {
                    color: 'rgba(0, 0, 0, 0.60)',
                },
                '&.inValid': {
                    color: '#5F2120',
                },
            },
            '& .iconButtonWrapper': {
                padding: '5px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '& .icon': {
                    width: '16px',
                    fontSize: '16px',
                },
                '& .valid': {
                    color: 'rgba(0, 0, 0, 0.56)',
                },
                '& .inValid': {
                    color: '#5F2120',
                    fontSize: '16px',
                    fontWeight: 900,
                },
            },
        },
        '& .errorMessage': {
            paddingLeft: '28px',
            color: '#5F2120',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '166%',
            letterSpacing: '0.4px',
            textWrap: 'wrap',
            wordBreak: 'break-all',
            whiteSpace: 'break-spaces',
        },
    },
}));
//# sourceMappingURL=styles.js.map